import QRCode from 'qrcodejs2';
import bchaddr from 'bchaddrjs';
import { ConstantUtil } from '@/utils/ConstantUtil';

export default {
    name: 'Dialog',
    props: ['depAddress', 'chainType', 'withdrawMini', 'depositMini', 'currTarget'],
    data() {
        return {
            showLegacy: false,
            qrcode: undefined,
        };
    },
    computed: {
        isBCH() {
            return ConstantUtil.BCHID.has(this.currTarget.id);
        },
        address() {
            if (this.isBCH) {
                return this.showLegacy ?
                    bchaddr.toLegacyAddress(this.depAddress) :
                    bchaddr.toCashAddress(this.depAddress);
            }
            return this.depAddress;
        },
    },
    mounted() {
        this.getAddress();
    },
    watch: {
        depAddress(n) {
            this.getAddress(n);
        },
    },
    methods: {
        goto(path) {
            return this.$router.push(path);
        },
        onClickCopy() {
            const self = this;
            self.$Message.success(self.$t('balance_copy_success'));
        },
        onToggle() {
            this.showLegacy = !this.showLegacy;
            this.getAddress();
        },
        getAddress(v) {
            if (this.qrcode) {
                this.qrcode.makeCode(v || this.address);
            } else {
                this.qrcode = new QRCode('qrcode', {
                    width: '150',
                    height: '150',
                    text: v || this.address,
                    colorDark: '#000',
                    colorLight: '#fff',
                });
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/common/deposit.js